module.exports = __webpack_public_path__ + "fr.0846f86e.svg";